const siteSiteLaunchTheme = {
    siteLaunch: {
        bgStart: '#fcfcfc',
        bgEnd: '#fcfcfc',
    },
};

export default siteSiteLaunchTheme;
